import React from "react";
import Image from "../../shared/Image";
import "./AppStoreButtons.scss";

/**
 * Reusable App Store Buttons Component
 * 
 * Accepts iOS and Android URLs as props for easy customization per campaign.
 * Default links can be overridden when duplicating the template.
 * 
 * @param {string} iosUrl - iOS App Store link (supports deep link params)
 * @param {string} androidUrl - Android Google Play link (supports intent URLs)
 */
const AppStoreButtons = ({
  iosUrl = "https://apps.apple.com/gb/app/dusk/id824241550",
  androidUrl = "https://play.google.com/store/apps/details?id=com.drinki.app&hl=en_GB"
}) => {
  return (
    <div className="has-text-centered app-store-buttons-container">
      <a
        href={iosUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          srcs={[
            require("../../assets/images/iconAppStore.png"),
            require("../../assets/images/iconAppStore@2x.png"),
            require("../../assets/images/iconAppStore@3x.png"),
          ]}
          alt="Download on the App Store"
          width={200}
        />
      </a>
      <a
        href={androidUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          srcs={[
            require("../../assets/images/iconGooglePlay.png"),
            require("../../assets/images/iconGooglePlay@2x.png"),
            require("../../assets/images/iconGooglePlay@3x.png"),
          ]}
          alt="Download on the Play Store"
          width={200}
        />
      </a>
    </div>
  );
};

export default AppStoreButtons;
